import { useState } from "react";
import { useNavigate } from "react-router";
import ComponentCard from "../../components/common/ComponentCard";
import Form from "../../components/form/Form";
import Label from "../../components/form/Label";
import Input from "../../components/form/input/InputField";
import Select from "../../components/form/Select";
import Button from "../../components/ui/button/Button";

const apiUrl = process.env.REACT_APP_API_URL;

export default function AddDietary() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    dietaryName: "",
    status: "",
  });
  const [errors, setErrors] = useState({
    dietaryName: "",
  });
  const [submitError, setSubmitError] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validate = () => {
    const nextErrors = { dietaryName: "" };
    if (!formData.dietaryName.trim()) {
      nextErrors.dietaryName = "Dietary name is required.";
    }
    setErrors(nextErrors);
    return Object.values(nextErrors).every((value) => !value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    if (!apiUrl) {
      setSubmitError("API URL is not configured.");
      return;
    }

    setSubmitError("");
    setSubmitLoading(true);
    try {
      const token = localStorage.getItem("token");
      const payload = {
        name: formData.dietaryName,
        status: formData.status,
      };

      const response = await fetch(`${apiUrl}/dietaries`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });

      const responseText = await response.text();
      let result: any = null;
      try {
        result = responseText ? JSON.parse(responseText) : null;
      } catch {
        result = null;
      }

      if (!response.ok || (result && result.success === false)) {
        throw new Error(result?.message || responseText || "Failed to add dietary.");
      }

      navigate("/dietaries");
    } catch (error) {
      setSubmitError(error instanceof Error ? error.message : "Failed to add dietary.");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <ComponentCard title="Add Dietary">
      <Form onSubmit={handleSubmit}>
        <div className="grid gap-6">
          <div className="col-span-full">
            <h4 className="border-b border-gray-200 pb-4 text-base font-medium text-gray-800 dark:border-gray-800 dark:text-white/90">
              Dietary
            </h4>
          </div>

          <div>
            <Label>Dietary Name</Label>
            <Input
              type="text"
              id="dietaryName"
              name="dietaryName"
              value={formData.dietaryName}
              onChange={handleChange}
            />
            {errors.dietaryName && <p className="text-sm text-red-500">{errors.dietaryName}</p>}
          </div>

          <div>
            <Label>Record Status</Label>
            <Select
              options={[
                { value: "current", label: "Current" },
                { value: "non-current", label: "Non-Current" },
              ]}
              value={formData.status}
              onChange={(value: string) => setFormData((prev) => ({ ...prev, status: value }))}
              className="mt-2 bg-gray-50 dark:bg-gray-800"
            />
          </div>

          {submitError && <p className="text-sm text-red-500">{submitError}</p>}

          <div className="flex gap-3">
            <Button size="sm" type="submit" disabled={submitLoading}>
              {submitLoading ? "Saving..." : "Save Changes"}
            </Button>
            <Button size="sm" variant="outline" type="button" onClick={() => navigate("/dietaries")}>
              Cancel
            </Button>
          </div>
        </div>
      </Form>
    </ComponentCard>
  );
}
